<style scoped>
.table {
  font-size: 85%;
  width: 100%;
}
</style>
<template>
  <div class="container">
    <div v-if="data.salesSummary.results.length > 0">
      <div class="row">
        <div class="col-12">
          <h5>Day Totals</h5>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="table-responsive">
            <table class="table table-sm table-striped frozen-table" v-if="data.salesSummary.results.length > 0">
              <thead>
                <tr class="table-header header text-left">
                  <th class="text-center">Date</th>
                  <th v-if="grossView" class="text-right">Gross Sales</th>
                  <th v-if="grossView" class="text-center">%</th>
                  <th class="text-right">Net Sales</th>
                  <th class="text-center">%</th>
                  <th class="text-right">Discounts</th>
                  <th class="text-center">% of Sales</th>
                  <th class="text-center">Checks</th>
                  <th class="text-center">%</th>

                  <th v-if="checkGuestStats" class="text-center">
                    Guests/
                    <br />Customers
                  </th>
                  <th v-if="checkGuestStats" class="text-right">PPA</th>
                  <th class="text-right">SPMH</th>
                  <th class="text-center">%</th>
                  <th class="text-right">
                    Labor
                    <br />Cost
                  </th>
                  <th class="text-center">% of Sales</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="border-right"
                  v-for="(v, index) in data.salesSummary.results"
                  :key="index"
                  v-show="data.salesSummary.results.length > 0"
                >
                  <td class="text-center">
                    {{ v.datename }}
                    <!-- <span v-if="v.location > 0 && index > 0">
                      <a class="text-primary" href v-on:click.prevent="openNoteModal(v.checkdate)">
                        <span class="oi oi-tag" title="View Notes/Weather"></span>
                      </a>
                    </span> -->
                  </td>
                  <td
                    v-if="!v.location"
                    colspan="20"
                    style="color: #666; background-color: #dfdfdf"
                    class="text-center"
                  >(NO DATA)</td>

                  <td v-if="grossView && v.location" class="text-right">
                    <sales-check-list-modal
                      v-bind:locationId="[v.location]"
                      v-bind:startDate="v.checkdate"
                    >{{ v.gross | currency }}</sales-check-list-modal>
                  </td>
                  <td v-if="grossView && v.location" class="text-center">
                    <span
                      v-if="v.grosspct"
                      v-bind:class="(v.grosspct > 0) ? 'text-success add-plus-sign' : 'text-danger'"
                    >{{ v.grosspct | number('0,0.0') }}%</span>
                  </td>
                  <td class="text-right" v-if="v.location">
                    <sales-check-list-modal
                      v-bind:locationId="[v.location]"
                      v-bind:startDate="v.checkdate"
                    >{{ v.net | currency }}</sales-check-list-modal>
                  </td>
                  <td class="text-center" v-if="v.location">
                    <span
                      v-if="v.netpct"
                      v-bind:class="(v.netpct > 0) ? 'text-success add-plus-sign' : 'text-danger'"
                    >{{ v.netpct | number('0,0.0') }}%</span>
                  </td>
                  <td class="text-right" v-if="v.location">
                    <sales-check-list-modal
                      v-bind:locationId="[v.location]"
                      v-bind:startDate="v.checkdate"
                      v-bind:discountOnly="1"
                    >{{ v.comps | currency }}</sales-check-list-modal>
                  </td>
                  <td
                    class="text-center"
                    v-if="v.location"
                  >{{ v.discountpersales | number('0,0.0') }}%</td>
                  <td class="text-center" v-if="v.location">{{ v.checks }}</td>
                  <td class="text-center" v-if="v.location">
                    <span
                      v-if="v.checkspct"
                      v-bind:class="(v.checkspct > 0) ? 'text-success add-plus-sign' : 'text-danger'"
                    >{{ v.checkspct | number('0,0.0') }}%</span>
                  </td>

                  <td v-if="checkGuestStats && v.location" class="text-center">{{ v.guestcount }}</td>
                  <td
                    v-if="checkGuestStats && v.location"
                    class="text-right"
                  >{{ v.perperson | currency }}</td>
                  <td class="text-right" v-if="v.location">{{ v.spmh | currency }}</td>
                  <td class="text-center" v-if="v.location">
                    <span
                      v-if="v.spmhpct"
                      v-bind:class="(v.spmhpct > 0) ? 'text-success add-plus-sign' : 'text-danger'"
                    >{{ v.spmhpct | number('0,0.0') }}%</span>
                  </td>
                  <td class="text-right" v-if="v.location">
                    <a
                      href
                      class="link"
                      v-on:click.prevent="openLaborModel(v.checkdate, data.location_id)"
                    >
                      <span>{{ v.laborcost | currency }}</span>
                    </a>
                  </td>
                  <td class="text-center" v-if="v.location">{{ v.laborpersales | number('0,0.0') }}%</td>
                </tr>
                <tr class="border-right" v-if="!data.salesSummary.results.length > 0">
                  <td class="text-center" colspan="8">NO DATA AVAILABLE</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="data.salesSummary && data.salesSummary.shifts && data.salesSummary.shifts.length > 0"
    >
      <div class="row">
        <div class="col-12">
          <h5>By Shift</h5>
        </div>
      </div>
      <div v-for="(s, sindex) in data.salesSummary.shifts" :key="sindex">
        <div class="row">
          <div class="col-12">
            <div class="table-responsive">
              <table class="table table-sm table-striped frozen-table">
                <thead>
                  <tr class="table-header header text-left">
                    <th class="text-center">{{ s.name }}</th>
                    <th v-if="grossView" class="text-right">Gross Sales</th>
                    <th v-if="grossView" class="text-center">%</th>
                    <th class="text-right">Net Sales</th>
                    <th class="text-center">%</th>
                    <th class="text-right">Discounts</th>
                    <th class="text-center">% of Sales</th>
                    <th class="text-center">Checks</th>
                    <th class="text-center">%</th>
                    <th v-if="checkGuestStats" class="text-center">
                      Guests/
                      <br />Customers
                    </th>
                    <th v-if="checkGuestStats" class="text-right">PPA</th>
                    <th class="text-right">
                      Labor
                      <br />Cost
                    </th>
                    <th class="text-center">% of Sales</th>
                  </tr>
                </thead>
                <tbody v-if="s.dates.length > 0">
                  <tr class="border-right" v-for="(v, dateindex) in s.dates" :key="dateindex">
                    <td class="text-center">{{ v.datename }}</td>
                    <td
                      v-if="!v.checks"
                      colspan="20"
                      style="color: #666; background-color: #dfdfdf"
                      class="text-center"
                    >(NO DATA)</td>
                    <td v-if="grossView && v.checks" class="text-right">
                      <sales-check-list-modal
                        v-bind:locationId="[v.location]"
                        v-bind:startDate="v.checkdate"
                        v-bind:shiftId="v.shiftid"
                      >{{ v.gross | currency }}</sales-check-list-modal>
                    </td>
                    <td v-if="grossView && v.checks" class="text-center">
                      <span
                        v-if="v.grosspct"
                        v-bind:class="(v.grosspct > 0) ? 'text-success add-plus-sign' : 'text-danger'"
                      >{{ v.grosspct | number('0,0.0') }}%</span>
                    </td>

                    <td class="text-right" v-if="v.checks">
                      <sales-check-list-modal
                        v-bind:locationId="[v.location]"
                        v-bind:startDate="v.checkdate"
                        v-bind:shiftId="v.shiftid"
                      >{{ v.net | currency }}</sales-check-list-modal>
                    </td>
                    <td class="text-center" v-if="v.checks">
                      <span
                        v-if="v.netpct"
                        v-bind:class="(v.netpct > 0) ? 'text-success add-plus-sign' : 'text-danger'"
                      >{{ v.netpct | number('0,0.0') }}%</span>
                    </td>
                    <td class="text-right" v-if="v.checks">
                      <sales-check-list-modal
                        v-bind:locationId="[v.location]"
                        v-bind:startDate="v.checkdate"
                        v-bind:shiftId="v.shiftid"
                        v-bind:discountOnly="1"
                      >{{ v.comps | currency }}</sales-check-list-modal>
                    </td>
                    <td
                      class="text-center"
                      v-if="v.checks"
                    >{{ v.discountpersales | number('0,0.0') }}%</td>
                    <td class="text-center" v-if="v.checks">{{ v.checks }}</td>
                    <td class="text-center" v-if="v.checks">
                      <span
                        v-if="v.checkspct"
                        v-bind:class="(v.checkspct > 0) ? 'text-success add-plus-sign' : 'text-danger'"
                      >{{ v.checkspct | number('0,0.0') }}%</span>
                    </td>
                    <td v-if="checkGuestStats && v.checks" class="text-center">{{ v.guests }}</td>
                    <td v-if="checkGuestStats && v.checks" class="text-right">
                      <span v-if="grossView">{{ v.grossppa | currency }}</span>
                      <span v-if="!grossView">{{ v.netppa | currency }}</span>
                    </td>
                    <td class="text-right" v-if="v.checks">
                      <a
                        href
                        class="link"
                        v-on:click.prevent="openLaborModel(v.checkdate, data.location_id, s.id)"
                      >{{ v.laborcost | currency }}</a>
                    </td>
                    <td
                      class="text-center"
                      v-if="v.checks"
                    >{{ v.labor_per_sales | number('0,0.0')}}%</td>
                  </tr>
                  <tr class="border-right" v-if="!data.salesSummary.shifts.length > 0">
                    <td class="text-center" colspan="20">NO DATA AVAILABLE</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from '@/services/UserService'
import salesCheckListModal from '@/components/modals/sales/salesCheckListModal'
import DailyJournalReportService from '@/services/DailyJournalReportService'
import DailyReportTab from './dailyReportTab'

export default {
  extends: DailyReportTab,
  components: {
    salesCheckListModal
  },
  data () {
    return {
      data: {
        salesSummary: {
          results: [],
          shifts: []
        }
      },
      loadTimeout: null
    }
  },
  computed: {
    grossView: function () {
      return UserService.getConfigOption('gross_sales_view').value === 'yes'
    },
    checkGuestStats: function () {
      return UserService.getConfigOption('avg_check_guest_stats').value === 'yes'
    }
  },
  methods: {
    openNoteModal: function (date) {
      // var modal = $uibModal.open({
      //   controller: 'DailyNoteModalCtrl',
      //   size: 'lg',
      //   backdrop: 'static',
      //   keyboard: false,
      //   templateUrl: '/templates/angular-widgets/daily-note-modal.tpl',
      //   resolve: {
      //     params: function () {
      //       return {
      //         location_id: this.data.location_id,
      //         businessdate: (date) || formatDateForDB(this.data.daily.date)
      //       }
      //     }
      //   }
      // })
      // modal.result.then(function (value) {
      //   if (value) {
      //   }
      // }, function (response) {
      // })
    },
    loadData: function () {
      if (this.isActive > 0 && this.loadTimeout === null) {
        this.loadTimeout = setTimeout(() => {
          this.$updateloading(1)
          DailyJournalReportService.getSalesSummary(this.locationId, this.dailyDate, (this.grossView ? 'gross' : 'net'))
            .then(res => {
              this.$updateloading(-1)
              this.data.salesSummary = res
              this.loadTimeout = null
            })
        }, 100)
      }
    }
  }
}
</script>
